export const defaultHTML = `<!-- Upload or enter your HTML code here... -->

<html>
  <head>
    <title>HTML Sample</title>
    <meta http-equivg="X-UA-Compatible" content="IE=edge">
    <style type="text/css">
      body {
        font-family: "Brandon";
        margin: 0 !important;
        background-color: white;
      }
      h1 {
        color: #333333;
      }
    </style>
  </head>
  <body>
    <h1>Heading No.1</h1>
    <input disabled type="button" value="Disabled" />
  </body>
</html>
`;
